import { Button, Stack, TextField, MenuItem, Box, LinearProgress } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { transferProspectLeadDepartment } from '../../../redux/features/globalSlice';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { CancelButton, UpdateButton } from '../../../components/mui/Buttons/Buttons';
import { prospect_leads_departments } from '../../../utils/constants/departmentDetails';

const LeadTransferUpdate = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const { loading } = useSelector((state) => state.global);

  const initialValues = {
    transferToDeptId: '',
    remarks: '',
  };
  const validationSchema = Yup.object({
    transferToDeptId: Yup.number().required('department is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,

    onSubmit: (values) => {
      const data = {
        prospectIds: [row.prospect_lead_id],

        remarks: values.remarks,

        transferToDeptId: values.transferToDeptId,
      };

      dispatch(transferProspectLeadDepartment(data)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            onClose(true);
          },
          onFailed: () => {
            console.log('Transfer department Failed');
          },
        });
      });
    },
  });
  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Stack spacing={3} mt={2}>
          <TextField
            select
            label="Transfer To Department"
            name="transferToDeptId"
            value={formik.values.transferToDeptId}
            onChange={formik.handleChange}
            fullWidth
          >
            {' '}
            {prospect_leads_departments.map((dept) => (
              <MenuItem key={dept.id} value={dept.id} disabled={dept.id === row?.current_department_id}>
                {dept.name}
              </MenuItem>
            ))}{' '}
          </TextField>

          {/* REMARKS */}
          <TextField
            label="Remarks"
            name="remarks"
            multiline
            rows={3}
            value={formik.values.remarks}
            onChange={formik.handleChange}
            fullWidth
          />

          {loading && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          )}

          {/* SUBMIT */}
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <CancelButton action={() => onClose(false)}>Cancel</CancelButton>

            <UpdateButton disabled={loading} type="submit">
              {loading ? 'Updating...' : 'Update'}
            </UpdateButton>
          </Stack>
        </Stack>
      </Form>
    </FormikProvider>
  );
};
export default LeadTransferUpdate;
